import { render, staticRenderFns } from "./Popup-notification.vue?vue&type=template&id=6ba1e2e6&scoped=true&"
import script from "./Popup-notification.vue?vue&type=script&lang=js&"
export * from "./Popup-notification.vue?vue&type=script&lang=js&"
import style0 from "./Popup-notification.vue?vue&type=style&index=0&id=6ba1e2e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba1e2e6",
  null
  
)

export default component.exports